import { createDecoratedRoute } from '@cp-shared-9/frontend-ui';
import { Authentication } from './Authentication';

export const AuthenticatedRoute = createDecoratedRoute('AuthenticatedRoute', Authentication);
